module.exports = __webpack_public_path__ + "img/dogeinsta.ba287a3a.jpeg";